import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import WidgetItemListWrap from '../../WidgetItemListWrap';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL,
  WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/widget/models';
import {
  SELECTED_SEARCH_TAG_LIST_TABLE_EMPTY_TEXT,
  SEARCH_TAG_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';

const SearchTagListModal = (props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    getTagList,
    data,
    onCheckTag,
    selectedTagList,
    selectedTagIdList,
    getRelatedTagList,
  } = props;
  const { listData, linkType } = data;
  const { list, filterOption, sortOption, pagination, summary = {} } = listData;

  return (
    <Modal
      title="태그 검색"
      isOpen={isOpen}
      width={1500}
      height={650}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-tag-list-modal-wrap">
        <WidgetItemListWrap title="선택된 태그">
          <Table
            className="selected-tag-list-table"
            emptyText={SELECTED_SEARCH_TAG_LIST_TABLE_EMPTY_TEXT}
            data={selectedTagList}
            sortable={false}
            defaultPageSize={1}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedTagIdList}
            onCheck={(list) => onCheckTag(list)}
            columns={() =>
              columns({
                getRelatedTagList,
              })
            }
          />
        </WidgetItemListWrap>

        <WidgetItemListWrap title="태그 리스트">
          <TableWithSummary
            className="tag-list-table"
            totalCnt={summary.totalCnt}
            emptyText={SEARCH_TAG_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType],
              sortOption: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL[linkType],
              pagination: LIST_PAGINATION_MODEL,
            }}
            data={list}
            maxHeight={380}
            showPagination
            filterOption={filterOption}
            sortOption={sortOption}
            pagination={pagination}
            getList={getTagList}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedTagIdList}
            onCheck={(list) => onCheckTag(list)}
            columns={(utils) =>
              columns({
                ...utils,
                getRelatedTagList,
              })
            }
            getTdProps={(state, rowInfo) => {
              return {
                className: selectedTagIdList.includes(rowInfo.original.id) ? 'selected' : '',
              };
            }}
          />
        </WidgetItemListWrap>
      </div>
    </Modal>
  );
};

export default SearchTagListModal;
